import 'semantic-ui-less/semantic.less';
import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import reportWebVitals from './reportWebVitals';
import { Auth } from 'aws-amplify';
import authStorage from './AuthenticationStorage';
import AppWithAuth from './AppWithAuth';
import './run-first.js'

const config = {
  Auth: {
    mandatorySignIn: true,
    region: process.env.REACT_APP_AWS_REGION,
    userPoolWebClientId: process.env.REACT_APP_USERPOOL_CLIENT_ID,
    userPoolId: process.env.REACT_APP_USERPOOL_ID,
    storage: authStorage,
  },
};

Auth.configure(config);

ReactDOM.render(
  <React.StrictMode>
    <AppWithAuth />
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
